<div class="card" style="border-radius: 5px;">

    <div class="card-header   d-flex  align-items-center">
        <mat-icon>nightlife</mat-icon>


        <h4 style="margin-bottom: 0px;" class="text-truncate"> &nbsp; &nbsp; {{menu.name}}</h4>
    </div>
    <div class="card-body row  d-flex justify-content-center no-padding " style="margin-left: 0px;
    margin-right: 0px;border-radius: 0px 0px 5px 5px;">

        <div *ngIf="menu.logo" class="col-12 mt-2 mb-2">
            <img src="{{menu.logo}}" alt="" style="width: 100%; ">

        </div>
        <div class="col-6">
            <button (click)="openInfo()" class="col-12" style="float: right;" mat-raised-button color="primary">
                <mat-icon>info</mat-icon> Información
            </button>
        </div>
        <div class="col-6">


            <button class="col-12" routerLink="/menus/{{menu.id}}" style="float: right;" mat-raised-button
                color="primary">Ver
                Menu</button>
        </div>
    </div>

</div>